import { useTranslation } from 'react-i18next';
import { PAGES } from 'modules/estatePlan/constants/enums';

const useGetAnswers = (page: PAGES) => {
  const { t } = useTranslation('answers');

  const result = t(page, { returnObjects: true }) as AccordionAnswer[];

  if (Array.isArray(result)) return result;

  return [];
};

export default useGetAnswers;
